module.exports = __webpack_public_path__ + "static/media/ZingBadgePlusModal.5df167d2.webp";